import Modal from "@via/components/modal.tsx";
import { ButtonColor } from "@via/utils/constants.tsx";
import { type FC } from "react";
import { useDeleteIntegrationToken } from "@via/api/integration-tokens.api";
import { ServiceTokenListItem } from "common";

type DeleteIntegrationTokenModalProps = {
  integrationToken: ServiceTokenListItem | null;
  setIntegrationTokenToBeDeleted: (
    integrationToken: ServiceTokenListItem | null
  ) => void;
};

const DeleteIntegrationTokenModal: FC<DeleteIntegrationTokenModalProps> = ({
  integrationToken,
  setIntegrationTokenToBeDeleted,
}) => {
  const {
    mutateAsync: deleteIntegrationToken,
    isPending: isDeleteIntegrationTokenLoading,
  } = useDeleteIntegrationToken();

  const handleDeleteIntegrationToken = async (
    id: string
  ): Promise<void | boolean> => {
    // Returning false keeps the dialog open. Resolving closes it through Modal's
    // setOpen, which is what clears the row being deleted, so there is one close
    // path rather than a success effect racing the dialog.
    if (!id) return false;
    await deleteIntegrationToken(id);
  };

  return (
    <Modal
      open={!!integrationToken}
      setOpen={() => {
        setIntegrationTokenToBeDeleted(null);
      }}
      title="Delete Integration Token"
      confirmText="Delete"
      confirmButtonColor={ButtonColor.Red}
      isConfirmLoading={isDeleteIntegrationTokenLoading}
      onConfirm={() =>
        handleDeleteIntegrationToken(integrationToken!.id.toString())
      }>
      <div className="flex flex-col py-2 text-sm leading-6 text-slate-600 md:py-3 lg:py-4">
        <p>
          {integrationToken?.selected && (
            <>
              <span>
                You are about to delete the selected token. If you delete this
                token, another token will be selected as the default token.
              </span>
              <br />
            </>
          )}
          Are you sure you want to delete token{" "}
          <span className="font-semibold">{integrationToken?.name}</span>?
        </p>
      </div>
    </Modal>
  );
};

export default DeleteIntegrationTokenModal;
